import React from 'react';
import { Text, View } from 'react-native';

import Icon from 'LocalGluons/components/Icon';
import { t } from 'Locale';

import defaultStyles from './TvCastOverlay.jss';

interface TvCastOverlayProps {
    castedDeviceName?: string;
}

const TvCastOverlay = ({ castedDeviceName }: TvCastOverlayProps): JSX.Element => (
    <View style={defaultStyles.container}>
        <View style={defaultStyles.title}>
            <Icon style={defaultStyles.icon} name="cast_appletv" />
            {!!castedDeviceName && (
                <Text style={defaultStyles.text}>
                    {t('PLAYER.PLAYING_ON')}
                    {` "${castedDeviceName}"`}
                </Text>
            )}
        </View>
    </View>
);

export default TvCastOverlay;
